import React from 'react'
import { Icon } from '@UILibrary/Icon'

interface StarRatingProps {
  rating: number
}

export const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const fullStars = Math.floor(rating)
  const emptyStars = 5 - fullStars

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* Render full stars */}
      {[...Array(fullStars)].map((_, index) => (
        <Icon key={`full-${index}`} name="star-filled" size="large" color="secondary-main-legacy" />
      ))}
      {/* Render empty stars */}
      {[...Array(emptyStars)].map((_, index) => (
        <Icon key={`empty-${index}`} name="star" size="large" color="secondary-main-legacy" />
      ))}
    </div>
  )
}
